import type { _RouteLocationBase } from 'vue-router'

export const hubspotTrackPageView = (to: _RouteLocationBase) => {
  const _hsq = window._hsq || []
  _hsq.push(['setPath', to.path])
  _hsq.push(['trackPageView'])
}
